export const TAB_NAMES = {
  items: "Items",
  stores: "Almacenes",
  periodicity: "Periodicidad de conteo",
};

export const VALID_TABS = [
  { name: TAB_NAMES.items, active: true, showProducts: true },
  { name: TAB_NAMES.stores, active: true, showProducts: true },
  { name: TAB_NAMES.periodicity, active: false, showProducts: false },
];

// user sesion data
export const TAB_KEY = "invAdminActiveTab";
export const SELECTED_STORE_KEY = "invSelectedStore";

// files
export const DEFAULT_EXTENSION = "png";
export const MAX_IMAGE_SIZE_MB = 1;
